import { connect } from 'react-redux'
import BottomBar from './BottomBar'

const mapStateToProps =
(state: TopHap.StoreState) => ({
  isGuest: !!state.user.paymentInfo?.ownerId,
  agentInfo: state.user.agentInfo || state.user.linkBrandedAgentInfo
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(BottomBar)
